export const endPoint = process.env.REACT_APP_API_ENDPOINT;
console.log("endPoint", endPoint);

const BASE_URL = `${endPoint}/api/`;

console.log("endPoint", endPoint);
export const API_ENDPOINTS = {
  BASE_URL: BASE_URL,
  //api url for CIODS
  GET_PUBLICATION_API: `${BASE_URL}ciods/publication_api`,
  GET_PUBIMAGE_API: `${BASE_URL}ciods/pubimage_api`,
  // GET_FACULTYIMAGE_API: `${BASE_URL}ciods/faculty`,
  GET_TEAMIMAGE_API: `${BASE_URL}ciods/team`,
  CIODS_CONTACT_US: `${BASE_URL}ciods/contact_us/`,
  NEW_PUBLICATION: `${BASE_URL}ciods/New_publication/`,
  NEW_PROFILE: `${BASE_URL}ciods/New_profile/`,
  UPDATE_PROFILE: `${BASE_URL}ciods/Update_profile`,

  POST_TOKEN: `${BASE_URL}ciods/admin_login/`,
  //   api url for VIrhostlncr
  GET_VIRUS_LIST: `${BASE_URL}virhostlncr/get_virus/`,
  GET_LNCRNA_LIST: `${BASE_URL}virhostlncr/lncrna_list/`,
  GET_TARGET_LIST: `${BASE_URL}virhostlncr/target_list/`,
  GET_VIRUS_DETAILS: `${BASE_URL}virhostlncr/viruses/`,
  GET_LNCRNA_DETAILS: `${BASE_URL}virhostlncr/lncrna/`,
  GET_TARGET_NETWORK: `${BASE_URL}virhostlncr/targetdetails/`,
  GET_SEARCH_RESULTS: `${BASE_URL}virhostlncr/search_lncrna/`,
  GET_BQUERY_RESULTS: `${BASE_URL}virhostlncr/search_bquery/`,
  VIRHOST_CONTACT_US: `${BASE_URL}virhostlncr/contact_us/`,

  //   api url for Drug resistant
  GET_DRUG_RESISTANT: `${BASE_URL}drug_resistant/unique_drugs/`,
  GET_MOLECULES_DRUG: `${BASE_URL}drug_resistant/filtered_data/`,
  GET_ANALYZE_RESISTANCE: `${BASE_URL}drug_resistant/analyze_resistance/`,
  GET_QUERY_OUTPUT: `${BASE_URL}drug_resistant/molecules_list/`,
  GET_DOWNLOAD_DATA: `${BASE_URL}drug_resistant/get_download_url/`,
  DRUGRESISTANT_CONTACT_US: `${BASE_URL}drug_resistant/contact_us/`,


  //   api url for ISOPROT
  GET_TOOL_OUTPUT_DATA: `${BASE_URL}isoprot/tool_output_api/`,
  GET_ALIGNMENT: `${BASE_URL}isoprot/alignment_api/`,
  GET_PTM_DATA: `${BASE_URL}isoprot/ptm_api/`,
  GET_DOMAIN_DATA: `${BASE_URL}isoprot/domain_api/`,
  GET_GENE_SUMMARY: `${BASE_URL}isoprot/gene_summary_api/`,
  GET_PTM_SITE_TABLE: `${BASE_URL}isoprot/ptm_details_api/`,
  GET_MUTATION_DATA: `${BASE_URL}isoprot/mutation_data_api/`,
  ISOPROT_CONTACT_US: `${BASE_URL}isoprot/contact_us/`,
  GET_GENE_LIST: `${BASE_URL}isoprot/get_all_genes_api/`,
  DOWNLOAD_ALL_TRANSCRIPT_DATA: `${BASE_URL}isoprot/download_transcript_data/`,
  DOWNLOAD_GENE_DATA: `${BASE_URL}isoprot/download_gene_summary_data/`,





  //   api url for HomoeOmics DB
  GET_DRUGS_LIST: `${BASE_URL}homoeomicsdb/drugs_api/`,
  GET_GENES_LIST: `${BASE_URL}homoeomicsdb/gene_api/`,
  GET_DISEASE_LIST: `${BASE_URL}homoeomicsdb/disease_api/`,
  GET_SEARCH_LIST: `${BASE_URL}homoeomicsdb/home_search_api/`,
  GET_SUGGESTIONS: `${BASE_URL}homoeomicsdb/get_suggestions_api/`,
  HOMOEOMICS_CONTACT_US: `${BASE_URL}homoeomicsdb/contact_us/`,


  //api url for GCPDB
  GET_BQUERY_DATA: `${BASE_URL}gcpdb/bquery_result/`,
  GET_PEPQUERY_DATA: `${BASE_URL}gcpdb/pep_query_result/`,
  POST_ANALYSE_DATA: `${BASE_URL}gcpdb/gene_ontology_combined/`,
  GET_SEARCH_BAR: `${BASE_URL}gcpdb/quick_search/`,
  GET_PEPFEATURE_DATA: `${BASE_URL}gcpdb/download_peptide_features/`,
  GCPDB_CONTACT_US: `${BASE_URL}gcpdb/contact_us/`,


  // api url for PXKD
  GET_CATEGORY: `${BASE_URL}pxkd/kinases_by_category/`,
  GET_KINASE: `${BASE_URL}pxkd/kinase_detail/`,
  GET_KINASE_RECORDS: `${BASE_URL}pxkd/kinase_records/`,
  GET_KINASE_FAMILY: `${BASE_URL}pxkd/kinase_family/`,
  GET_NEW: `${BASE_URL}pxkd/family_fasta_and_kinases/`,
  PXKD_CONTACT_US: `${BASE_URL}pxkd/contact_us/`,



  //tsp
  GET_TSP_ALIGNMENT: `${BASE_URL}tsp/family_fasta_and_kinases/`,
  GET_TSP_FAMILY: `${BASE_URL}tsp/result/`,




  //api url for BCDRDB
  POST_HEATMAP: `${BASE_URL}bcdrdb/heatmap/`,
  GET_BROWSE :`${BASE_URL}bcdrdb/bcdrdb_all/`,
  BCPDB_CONTACT_US :`${BASE_URL}bcdrdb/contact_us/`,



  //api url for lollipop external
  POST_DNA_OUTPUT: `${BASE_URL}m2viz/dnaoutput/`,
  POST_PROTEIN_P_OUTPUT: `${BASE_URL}m2viz/protein_p_output/`,
  POST_PROTEIN_D_OUTPUT: `${BASE_URL}m2viz/protein_d_output/`,
  LOLLIPOP_CONTACT_US: `${BASE_URL}m2viz/contact_us/`,
  




  //api url for METABOLITE
  META_SEARCH: `${BASE_URL}metabolite/search_api/`,
  METABOLITE_AUTOCOMPLETE: `${BASE_URL}metabolite/autocomplete/`,
  GET_ENZYME_INTERACTORS: `${BASE_URL}metabolite/get_enzyme_interactors/`,
  PATHWAY_AUTOCOMPLETE: `${BASE_URL}metabolite/pathway_autocomplete/`,
  PROTEIN_AUTOCOMPLETE: `${BASE_URL}metabolite/protein_autocomplete/`,
  KINASE_AUTOCOMPLETE: `${BASE_URL}metabolite/kinase_autocomplete/`,
  GET_PTM_NETWORK: `${BASE_URL}metabolite/get_ptmnetwork/`,
  META_TOOL: `${BASE_URL}metabolite/metabolic_tool/`,
  PATHWAY_SUBSTRATE: `${BASE_URL}metabolite/get_pathways_by_substrate/`,
  PTM_DATA: `${BASE_URL}metabolite/ptm-data/`,
  KINASE_PAGE_DATA: `${BASE_URL}metabolite/kinase-page-data/`,



  //api url for kinasedisorder prediction
  POST_PREDICT: `${BASE_URL}kindispredictor/predict/`,

  //api url for KRMapping
  GET_CYTO_OUTPUT: `${BASE_URL}krmap/cytooutput/`,
  KINASES_AUTOCOMPLETE: `${BASE_URL}krmap/kinases/`,
  KINASES_BUBBLES: `${BASE_URL}krmap/allkinases/`,
  GET_REGULATION_CYTO: `${BASE_URL}krmap/regulationcyto/`,



  //CALNET
  GET_GENE_DATA: `${BASE_URL}calnet/get_gene/`,
  GET_DOMAIN_DATA_CAL: `${BASE_URL}calnet/get_domain_data_api/`,
  GET_DISEASE_DATA: `${BASE_URL}calnet/get_disease_association_data_api/`,
  GET_SUBCELLULAR_DATA: `${BASE_URL}calnet/get_subcellular_localization_data_api/`,
  GET_PROTEIN_INTERACTION: `${BASE_URL}calnet/get_protein_interactions_api/`,
  // GET_PROTEIN_STRUCTURE: `${BASE_URL}calnet/get_protein_structures/`,
  GET_PROTEIN_STRUCTURE_BY_GENE: `${BASE_URL}calnet/protein-structures/`,



  // //api url for lollipop
  // POST_P_OUTPUT:`${BASE_URL}lollipop/poutput/`,
  // POST_D_OUTPUT:`${BASE_URL}lollipop/doutput/`,


  // Viral Omics
  VIRUS_SUGGESTIONS:    `${BASE_URL}viralomics/suggestions/`,
  VIRUS_CARDS:          `${BASE_URL}viralomics/virus-cards/`,
  VIRUS_SEARCH:         `${BASE_URL}viralomics/search/`,
  VIRUS_FILTER_OPTIONS: `${BASE_URL}viralomics/filter-options/`,
  VIRUS_GSE_METADATA:   (gseId) => `${BASE_URL}viralomics/gse/${gseId}/metadata/`,
  VIRUS_GSE_EXPRESSION: (gseId) => `${BASE_URL}viralomics/gse/${gseId}/expression/`,
  INFLAMMATORY_ANALYSIS: `${BASE_URL}viralomics/inflammatory-analysis/`,
  GSE_GENES:            `${BASE_URL}viralomics/gse-genes/`,
  LR_PAIR_ANALYSIS:     `${BASE_URL}viralomics/lr-pair-analysis/`,
  LR_PAIR_TABLE: `${BASE_URL}/viralomics/lr-pair-table/`,
  CROSS_DATA_ANALYSIS: `${BASE_URL}viralomics/cross-data-analysis/`,
  TRANSMEMBRANE_ANALYSIS: `${BASE_URL}viralomics/transmembrane-analysis/`,
  ANALYSE: `${BASE_URL}viralomics/analyse/`,
  





  // Affinix
  AFFINIX_PREDICT: `${BASE_URL}affinix/predict/`,
  AFFINIX_DPSS: `${BASE_URL}affinix/dpss/`,
  AFFINIX_METRICS: `${BASE_URL}affinix/metrics/`,


  // Virvin
  SERUM_PROFILE: `${BASE_URL}virvin/serum_profile/`,
  SERUM_PROFILE_DISEASE_SUMMARY: `${BASE_URL}virvin/serum_profile_summary/`,
  SERUM_DIFFERENTIAL: `${BASE_URL}virvin/serum_differential/`,
  SERUM_DIFF_DISEASE_SUMMARY: `${BASE_URL}virvin/serum_differential_summary/`,
  PLASMA_PROFILE: `${BASE_URL}virvin/plasma_profile/`,
  PLASMA_PROFILE_DISEASE_SUMMARY: `${BASE_URL}virvin/PlasmaProfileDiseaseSummary/`,
  PLASMA_DIFFERENTIAL: `${BASE_URL}virvin/plasma_differential/`,
  PLASMA_DIFF_DISEASE_SUMMARY: `${BASE_URL}virvin/PlasmaDiffDiseaseSummary/`,
  VIRUS_CHARTS_DATA: `${BASE_URL}virvin/virus_counts/`,
  FUNCTIONAL_ANALYSIS: `${BASE_URL}virvin/functional_analysis/`,
  ENRICHMENT_PATHWAY: `${BASE_URL}virvin/enrichment_pathway/`,
  FAMILY_CLUSTERING: `${BASE_URL}virvin/family_clusters/`,
  ANALYSIS: `${BASE_URL}virvin/analysis/`,
  LIGAND_INTERACTION: `${BASE_URL}virvin/ligand_interaction/`,
  BATCH_QUERY: `${BASE_URL}virvin/BatchQuery/`,
  PVALUE_ANALYSIS: `${BASE_URL}virvin/p_value_analysis/`,
  KEGG_PATHWAY: `${BASE_URL}virvin/kegg_pathway/`,
  GO_ENRICHMENT: `${BASE_URL}virvin/go_enrichment/`,
  HUMAN_VIRAL_PPI: `${BASE_URL}virvin/human_viral_ppi/`,
  HUMAN_PPI: `${BASE_URL}virvin/human_ppi/`,
  VIRUSES: `${BASE_URL}virvin/viruses/`,
  HOMOVIR_CONTACT_US: `${BASE_URL}virvin/contact_us/`,
  HOMOVIR_DATA_SUBMISSION: `${BASE_URL}virvin/data_submission/`,

  // AutoPhospho
  AUTOPHOSPHO_KINASES: `${BASE_URL}autophospho/kinase_information/`,
  AUTOPHOSPHO_POSITIONAL_DISTRIBUTION: `${BASE_URL}autophospho/positional_distribution/`,
  AUTOPHOSPHO_FUNCTION: `${BASE_URL}autophospho/autophosphorylation/`,
  AUTOPHOSPHO_IDPPUB: `${BASE_URL}autophospho/idppub/`,
  AUTOPHOSPHO_CONSERVATION_PLOT: `${BASE_URL}autophospho/conservation_plot/`,
  AUTOPHOSPHO_SEQUENCE_ANALYSIS: `${BASE_URL}autophospho/sequence_analysis/`,
  AUTOPHOSPHO_CONTACT_US: `${BASE_URL}autophospho/contact_us/`,


  // RetinaIntel
  RETINAINTEL_PREDICT: `${BASE_URL}retinaintel/predict/`,


  // // CIODS Connect
  // CIODSCONNECT_REGISTER: `${BASE_URL}ciodsconnect/auth/register/`,
  // CIODSCONNECT_LOGIN: `${BASE_URL}ciodsconnect/auth/login/`,
  // CIODSCONNECT_REFRESH: `${BASE_URL}ciodsconnect/auth/refresh/`,
  // CIODSCONNECT_DASHBOARD: `${BASE_URL}ciodsconnect/dashboard/`,


  // CIODS Connect
  CIODSCONNECT_REGISTER: `${BASE_URL}ciodsconnect/auth/register/`,
  CIODSCONNECT_LOGIN: `${BASE_URL}ciodsconnect/auth/login/`,
  CIODSCONNECT_ADMIN_LOGIN: `${BASE_URL}ciodsconnect/auth/admin-login/`,
  CIODSCONNECT_REFRESH: `${BASE_URL}ciodsconnect/auth/refresh/`,
  CIODSCONNECT_DASHBOARD: `${BASE_URL}ciodsconnect/dashboard/`,
  CIODSCONNECT_ORGANISATION_DASHBOARD: `${BASE_URL}ciodsconnect/organisation-dashboard/`,
  CIODSCONNECT_MANAGEMENT_EMPLOYEES: `${BASE_URL}ciodsconnect/management/employees/`,
  CIODSCONNECT_MANAGEMENT_TEAMS: `${BASE_URL}ciodsconnect/management/teams/`,



}
